export function getSeriesTitle(series: { title: string }): string {
  return series.title;
}
